import React from "react"; // Required for JSX even if not explicitly used
import { Label } from './ui/label';
import { Input } from './ui/input';

interface InputSettingRowProps {
  label: string;
  id: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  placeholder?: string;
}

export default function InputSettingRow({ label, id, value, onChange, type = 'text', placeholder }: InputSettingRowProps) {
  return (
    <div className="flex items-center justify-between border-b border-[color:var(--jr-border)] bg-transparent px-4 py-4">
      <Label htmlFor={id} className="flex-grow text-base text-[var(--jr-text)]">{label}</Label>
      <Input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="jr-input w-24 text-right"
      />
    </div>
  );
}
